import { withI18nPlaceholders } from '@change-corgi/core-react/i18n';

import I18N_PLACEHOLDERS from '#config/i18n/placeholders/local-signer-share/local-signer-share.yml';

import { LocalSignerShareComponent } from './LocalSignerShare';

export type { LocalShareAction } from './LocalSignerShare';

// Experimental: placeholders are bundled with the component until the copy is locked.
export const LocalSignerShare = withI18nPlaceholders(I18N_PLACEHOLDERS, LocalSignerShareComponent);
